import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../shared/services/global.service';
import {CityService} from '../../../shared/services/city.service';
import {TopStudyLocationService} from '../../../shared/services/top-study-location.service';

@Component({
    selector: 'app-add-top-study-location',
    templateUrl: './add-top-study-location.component.html',
    styleUrls: ['./add-top-study-location.component.scss']
})
export class AddTopStudyLocationComponent implements OnChanges {
    addTopStudyLocationForm: FormGroup;
    id: any;
    submitted: any = false;
    submitting: any = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;
    cities = [];

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                private topStudyLocationService: TopStudyLocationService,
                private cityService: CityService) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-top-study-location').toggleOpen();
    }

    refresh() {
        this.addTopStudyLocationForm = this.fb.group({
            'city_id': ['', Validators.required]
        });
        this.getCities();
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addTopStudyLocationForm.patchValue({
            'city_id': (this.data && this.data['city_id']) ? this.data['city_id'] : ''
        });
    }

    getCities(params: any = {}) {
        this.cities = [];
        this.cityService.get({'page': -1}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.cities = data['data'];
            } else {
                this.cities = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }


    submit() {
        this.submitted = true;
        if (!this.addTopStudyLocationForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'city_id': (this.addTopStudyLocationForm.value && this.addTopStudyLocationForm.value.city_id) ? this.addTopStudyLocationForm.value.city_id : ''
            };
            this.submitting = true;
            this.topStudyLocationService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addTopStudyLocationForm.reset();
                    this.addTopStudyLocationForm.patchValue({
                        'city_id': ''
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].city_id && error['error']['errors'].city_id.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].city_id[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addTopStudyLocationForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'city_id': (this.addTopStudyLocationForm.value && this.addTopStudyLocationForm.value.city_id) ? this.addTopStudyLocationForm.value.city_id : ''
            };
            this.submitting = true;
            this.topStudyLocationService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].city_id && error['error']['errors'].city_id.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].city_id[0]);
                        return;
                    }
                }
            });
        }
    }
}
